import { InitialLoader } from 'components/common/InitialLoader/InitialLoader';

/**
 * Renders an interstitial page during sign in
 */
export const SignInRedirectPage: React.FC = () => {
  return <InitialLoader />;
};
